// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  instanceId: __t.u64().primaryKey().name("instance_id"),
  projectId: __t.u64().name("project_id"),
  parentId: __t.u64().name("parent_id"),
  kind: __t.string(),
  transform: __t.string(),
  props: __t.string(),
  assetId: __t.u64().name("asset_id"),
  createdAt: __t.timestamp().name("created_at"),
});
